import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import T from '../../i18n/i18n';
import * as Tag from './TableForm.styles';
import TableDataForm from '../../TableDataForm/TableDataForm';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import TemplateManager from '../../Table/TemplateManager/TemplateManager';
import FileManager from '../../Table/FileManager/FileManager'; 
import { createTable } from '../../../services/tables';

export default () => {

    const history = useHistory();
    
    const [tabledata, setTableData] = useState({});
    const [error, setError] = useState(null);
    
    const handleBack = () => {
        history.goBack();
    };

    const validateName = () => {
        if (tabledata.name) {
            return true;
        }
    }

    const handleConfirm = async () => {
        let validation = validateName();
        if (!validation) {
            return;
        }

        let table = await createTable(tabledata);
        if (table.id) {
            history.replace(`/table/${table.id}`);
        } else if(table.status === 'error') {
            setError(table.payload.error ? table.payload.error.message : table.payload);
        }
    }

    return <>
        <Tag.HeaderRow>
            <Tag.ButtonBack color="#aaa" onClick={handleBack} />
            <Tag.Title><T value="tableform.title" /></Tag.Title>
        </Tag.HeaderRow>

        <TableDataForm 
            onChange={setTableData} 
            value={tabledata}
            error={error}
            />

        <Tag.FooterRow>
            <Tag.Button className='special' color="#999" onClick={handleBack}><T value="cancel" /></Tag.Button>
            <Tag.Button className='special' color="#0c0" onClick={handleConfirm}><T value="tableform.create" /></Tag.Button>
        </Tag.FooterRow>

        <ErrorBoundary id="templateManager">
            <TemplateManager />
        </ErrorBoundary>

        <FileManager />
        
    </>
};